<template>
<v-form
  class="certificate-form"
  :class="{ 'certificate-form--disabled': disabled  }"
  ref="form"
  @submit.prevent="apply"
>
  <div
    class="certificate-form_applied"
    v-for="cert, i in certificates"
    :key="i"
  >
    <span>
      {{ i + 1 }}. Сертификат {{ cert.code }}
    </span>

    <span class="certificate-form_applied-price">
      Сумма: <span class="fw-black">{{ formatPrice(cert.price) }}</span>
    </span>

    <a
      href="javascript:void(0)"
      class="certificate-form_applied-del"
      @click.prevent="unapply(cert.code)"
    >
      <v-icon>mdi-close-circle</v-icon>
    </a>


  </div>

  <div class="certificate-form_inner">
    <div class="certificate-form_fields">
      <ui-field label="Номер сертификата">
        <v-text-field
          solo
          class="ui-input"
          label="000000-000000-000000"
          v-mask="mask"
          v-model="code"
          :rules="rules"
          validate-on-blur
          hide-details="auto"
          :messages="messages"
          :error="isFieldErrored"
          @input="onInput"
        />
      </ui-field>
    </div>

    <div class="certificate-form_actions">
      <button
        type="submit"
        class="ui-btn certificate-form_action"
      >
        Применить
    </button>
    </div>
  </div>

  <div class="certificate-form_disabled-overlay"></div>
</v-form>
</template>

<script>
import { IMaskDirective } from 'vue-imask'
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  name: `certificate-form`,

  directives: {
    imask: IMaskDirective
  },

  props: {
    firstBillIsPayed: {
      type: Boolean,
      default: null,
    },
  },

  data: () => ({
    code: ``,
    rules: [
      v => {
        const pattern = /^[A-F0-9]{6}-[A-F0-9]{6}-[A-F0-9]{6}$/
        return !!v ? pattern.test(v) || 'Неверный формат номера сертификата.' : true
      }
    ],
    messages: [],
    isFieldErrored: false,
    mask: [
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      `-`,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      `-`,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
      /[A-F0-9]/,
    ],
  }),

  computed: {
    ...mapState({
      certificates: state => state.selection.certificates,
      isPrepayment: state => state.selection.isPrepayment,
      paymentMethod: state => state.selection.paymentMethod,
      savedData: state => state.selection.savedBookingInfo,
    }),

    ...mapGetters({
      udsData: `loyalty/getUdsData`,
    }),

    disabled() {
      const paymentBlockList = [`credit`, `installment`]
      let isUdsApplied = Object.keys(this.udsData).length
      return this.isPrepayment
        || paymentBlockList.findIndex((el) => el === this.paymentMethod) !== -1
        || isUdsApplied
        || this.firstBillIsPayed
    }
  },

  methods: {
    ...mapMutations({
      setIsLoading: 'setIsLoading',
      addCertificate: 'selection/addCertificate',
      removeCertificate: 'selection/removeCertificate',
    }),

    onInput() {
      this.messages = []
      this.isFieldErrored = false
    },

    async apply() {
      let isValid = this.$refs.form.validate()
      if(!this.code) {
        this.messages = [`Введите номер сертификата`]
        this.isFieldErrored = true
        isValid = false
      }
      if(!isValid) return

      // find cert code in applied
      let isAlreadyApplied = this.certificates.findIndex((cert) => cert.code === this.code) !== -1
      if(isAlreadyApplied) {
        this.messages = `Сертификат уже применен`
        this.isFieldErrored = true
        return
      }

      this.setIsLoading(true)
      this.$http
        .post(`/certificate/checkCertificate/`, { // solar:certificate.api.checkcertificate
          code: this.code,
          dealId: this.savedData.dealId
        })
        .then((resp) => {
          if(resp.data.data.status === `success`) {
            this.addCertificate({ code: this.code, price: resp.data.data?.price || 0 })
            this.code = ``
          } else {
            this.messages = resp.data.data.message
            this.isFieldErrored = true
          }
          // console.log(resp)
        })
        .finally(() => {
          this.setIsLoading(false)
        })
    },

    async unapply(code) {
      try {
        const resp = await this.$http.post(`/certificate/unlinkCertificate/`, { code }) // solar:certificate.api.unlinkcertificate
        if(resp.data.data.status === `success`) {
          this.removeCertificate(code)
        } else {
          // alert(`Ошибка при выполнении запроса`)
          console.error(e)
        }
      } catch(e) {
        // alert(`Ошибка при выполнении запроса`)
        console.error(e)
      }

    },

    unapplyAll() {
      this.certificates.forEach((cert) => {
        this.unapply(cert.code)
      })
    },

    formatPrice(num) {
      return typeof num === `number` ? `${String(num).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')} р` : `0`
    }
  },

  watch: {
    disabled(v) {
      if(v && !this.firstBillIsPayed) {
        this.unapplyAll()
      }
    },
  },

  created() {
    // this.setIsLoading(false)
  }
}

// function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms))
// }
</script>

<style lang="sass">
.certificate-form
  width: 100%
  position: relative

  &--disabled
    .certificate-form_disabled-overlay
      display: block

.certificate-form_disabled-overlay
  position: absolute
  inset: 0
  background-color: rgba(255,255,255, .5)
  z-index: 1
  display: none

.certificate-form_applied
  width: 100%
  display: flex
  align-items: center
  justify-content: space-between
  color: #696D74

  + .certificate-form_applied
    margin-top: px-em(20)

  + .certificate-form_inner
    margin-top: px-em(40)

.certificate-form_applied-price
  width: px-em(140)

.certificate-form_applied-del
  display: flex
  align-items: center
  justify-content: center
  text-decoration: none
  color: #C01717 !important
  font-size: px-em(22)
  line-height: 1

  .v-icon.v-icon
    font-size: inherit
    color: inherit

  .v-icon__component
    width: 1em
    height: auto

.certificate-form_inner
  width: 100%
  max-width: px-em(700)
  display: flex

.certificate-form_fields
  flex-grow: 1
  min-width: 1px

.certificate-form_actions
  padding-top: px-em(24)
  margin-left: px-em(20)
</style>
